class GmwProductType {
    static factory() {
        const factoryFunction = (HoldingCurrencies) => {
            return (input) => {
                if (!input) {
                    return undefined;
                }
                const currency = HoldingCurrencies.getCurrencyByCode(input.currency || input);
                return currency.type;
            };
        };
        factoryFunction.$inject = ['HoldingCurrencies'];
        return factoryFunction;
    }
}
export default angular
    .module('gm.wealth.common')
    .filter('gmwProductType', GmwProductType.factory()).name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/filters/product-type.ts